const badgeDataLayer = () => {
    const buttonsDownload = document.querySelectorAll('.download-file');
    const titleBadge = document.querySelector('[datalayer-title-badge]').getAttribute('datalayer-title-badge');

    window.dataLayer = window.dataLayer || [];

    buttonsDownload.forEach((button) => {
        button.addEventListener('click', (event) => {
            const parentElementFase = event.target.closest('[datalayer-fase]');
            const parentElementTitle = event.target.closest('.material-item');
            const valueFase = parentElementFase.getAttribute("datalayer-fase");
            const titleFile = parentElementTitle.querySelector('.title-file h4').innerHTML;

            window.dataLayer.push({
                'event': 'file_download_sucesso',
                'file_titulo': titleFile,
                'file_etapa': valueFase,
                'name_selo': titleBadge,
            });
        });
    });

    console.log(window.dataLayer);
}

export { badgeDataLayer };